import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_ai-photo-builder-2/artifacts/lpxdoe9g_Logo%20Fundo%20Transparente.png";

const navLinks = [
  { label: "Metodologia", href: "#curriculum" },
  { label: "Resultados", href: "#preview" },
  { label: "Galeria", href: "#gallery" },
  { label: "FAQ", href: "#faq" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-black/80 backdrop-blur-xl border-b border-white/10"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between h-16 md:h-20">
        <a href="#" className="flex items-center gap-3" data-testid="navbar-logo">
          <img src={LOGO_URL} alt="Advanse IA" className="h-8 md:h-10 w-auto" />
          <span className="font-['Outfit'] font-semibold text-lg tracking-tight text-white">
            ADVANSE <span className="text-[#00FF00]">IA</span>
          </span>
        </a>

        {/* Desktop nav */}
        <div className="hidden md:flex items-center gap-10">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="text-sm font-medium text-white/70 hover:text-[#00FF00] transition-colors duration-300 tracking-wide"
              data-testid={`nav-link-${link.label.toLowerCase()}`}
            >
              {link.label}
            </a>
          ))}
          <a href="#register">
            <Button
              data-testid="nav-cta-button"
              className="bg-[#00FF00] text-black font-semibold hover:bg-[#33FF33] rounded-none px-6 h-10 text-sm tracking-wide shadow-[0_0_20px_rgba(0,255,0,0.2)] hover:shadow-[0_0_30px_rgba(0,255,0,0.4)] transition-all duration-300"
            >
              INSCREVA-SE
            </Button>
          </a>
        </div>

        {/* Mobile menu button */}
        <button
          data-testid="mobile-menu-button"
          className="md:hidden text-white p-2"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          {menuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div
          data-testid="mobile-menu"
          className="md:hidden bg-black/95 backdrop-blur-xl border-t border-white/10 animate-fade-in"
        >
          <div className="px-6 py-6 flex flex-col gap-4">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="text-base text-white/70 hover:text-[#00FF00] transition-colors py-2"
                onClick={() => setMenuOpen(false)}
              >
                {link.label}
              </a>
            ))}
            <a href="#register" onClick={() => setMenuOpen(false)}>
              <Button className="w-full bg-[#00FF00] text-black font-semibold hover:bg-[#33FF33] rounded-none h-12 text-sm tracking-wide mt-2">
                INSCREVA-SE
              </Button>
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}
